<!-- Page Banner -->
<div class="page-banner-area item-bg4">
    <div class="container">
        <div class="page-banner-content">
            <h2>Apply Job</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Apply Job</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->


<!-- Contact -->
<section class="contact-area pb-100">
    <div class="container">
        <div class="section-title">
            <h2>Fill the form and upload your resume.</h2>
            <div class="bar"></div>
        </div>

        <div class="contact-form">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="form-group mb-3">
                        <label>Upload CV* (1 MB Max Upload)</label>

                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <div class="form-group mb-3">
                        <input type="file" id="cvfile" #file placeholder="Choose file" (change)="uploadFile(file.files)"
                            accept=".pdf,.doc,.docx">
                        <div class="alert alert-success" *ngIf="uploadMessage">
                            {{uploadMessage}}</div>
                    </div>
                </div>
            </div>
            <form id="applyjobForm" [formGroup]="applyjobForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>First Name*</label>
                            <input type="text" class="form-control" formControlName="firstName" maxlength="45"
                                [ngClass]="f.firstName.touched || submitted? f.firstName.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.firstName.touched ||submitted) && f.firstName.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.firstName.errors.required">First Name is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Last Name*</label>
                            <input type="text" class="form-control" formControlName="lastName" maxlength="45"
                                [ngClass]="f.lastName.touched || submitted? f.lastName.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.lastName.touched ||submitted) && f.lastName.errors" class="invalid-feedback">
                                <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Your email*</label>
                            <input type="email" class="form-control" formControlName="email" maxlength="100"
                                [ngClass]="f.email.touched || submitted? f.email.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.email.touched ||submitted) && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required">Email is required</div>
                                <div *ngIf="f.email.errors.email">Email ID is invalid</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Total Experience*</label>
                            <input type="text" class="form-control" formControlName="totalExperience" maxlength="100"
                                [ngClass]="f.totalExperience.touched || submitted? f.totalExperience.errors? 'is-invalid': 'is-valid':''">
                            <div *ngIf="(f.totalExperience.touched ||submitted) && f.totalExperience.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.totalExperience.errors.required">Total Experience is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Referral Name</label>
                            <input type="text" class="form-control" formControlName="referralName" maxlength="100"
                                [ngClass]="f.referralName.touched || submitted? f.referralName.errors? 'is-invalid': 'is-valid':''">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>Country</label>
                            <select formControlName="countryId" class="form-control" id="countryId"
                                style="display: block!important;"
                                [ngClass]="f.countryId.touched || submitted? f.countryId.errors? 'is-invalid': 'is-valid':''">

                                <option *ngFor="let item of countries" [ngValue]="item.id">{{item.countryName}}
                                </option>
                            </select>
                            <div *ngIf="(f.countryId.touched ||submitted) && f.countryId.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.countryId.errors.required">Country Required</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                        <div class="form-group mb-3">
                            <label>Your Skills*</label>
                            <textarea class="form-control" cols="30" rows="5" formControlName="skills" maxlength="1000"
                                [ngClass]="f.skills.touched || submitted? f.skills.errors? 'is-invalid': 'is-valid':''"></textarea>
                            <div *ngIf="(f.skills.touched ||submitted) && f.skills.errors" class="invalid-feedback">
                                <div *ngIf="f.skills.errors.required">Skills are required</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="form-group mb-3">
                            <label>How did you hear about us?</label>
                            <select class="form-control" id="hearAbouts" formControlName="hearAboutId"
                                [ngClass]="f.hearAboutId.touched || submitted? f.hearAboutId.errors? 'is-invalid': 'is-valid':''">

                                <option *ngFor="let item of hearAbouts" [ngValue]="item.id">{{item.hearAboutUsName}}
                                </option>
                            </select>
                            <div *ngIf="(f.hearAboutId.touched ||submitted) && f.hearAboutId.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.hearAboutId.errors.required">Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <ngx-recaptcha2 #captchaEle [siteKey]="siteKey" formControlName="recaptcha"></ngx-recaptcha2>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <button *ngIf="!loader" type="submit" [disabled]="!applyjobForm.valid"
                            class="default-btn">Submit</button>
                        <button *ngIf="loader" class="default-btn" type="button" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            Sending...
                        </button>
                    </div>
                </div>
            </form>
            <div class="mt-2 alert " [ngClass]="classType">
                <strong>{{messageType}}</strong> {{message}}
            </div>
        </div>
    </div>
</section>
<!-- End Contact -->